import {
  AifcExperienceTrackingCommand,
  ROVO_CHAT_CLIENT_ID,
  type AifcExperienceTrackingCommandProperties
} from '@atlassian/rovo-content-bridge-api-commands';

import { isRovoPreview } from '@canvas/frame-api/host-api/host-frame-context';
import { client } from '@canvas/rovo-content-bridge-api';

import { bridgeEventEmitter } from '../bridge-command-emitter.ts';

type AIFCExperienceName = 'aiMateAifcAllDataHandled' | 'aiMateAifcInitialDataReceived';

type SendDatabaseAIFCExperienceTrackingParams =
  | {
      status: 'fail';
      error: Error;
      experienceName: AIFCExperienceName;
      contentId: string;
    }
  | {
      status: 'success';
      experienceName: AIFCExperienceName;
      contentId: string;
    };

export const sendDatabaseAIFCExperienceTrackingToParent = (
  params: SendDatabaseAIFCExperienceTrackingParams
) => {
  const { status, experienceName, contentId } = params;

  const baseProps = {
    status,
    actionType: 'database' as const,
    actionId: contentId,
    senderId: client(`confluence-database-${contentId}`),
    receiverId: ROVO_CHAT_CLIENT_ID,
    experienceName,
    contentContext: isRovoPreview() ? ('staging-area' as const) : ('global' as const)
  };

  const commandProps: AifcExperienceTrackingCommandProperties =
    status === 'fail'
      ? { ...baseProps, status, error: params.error.message }
      : { ...baseProps, status };

  bridgeEventEmitter.sendEvent(AifcExperienceTrackingCommand, commandProps);
};
